import { NgModule, SkipSelf, Optional, APP_INITIALIZER } from '@angular/core';
import { FooterComponent } from './components/footer/footer.component';
import { HeaderComponent } from './components/header/header.component';
import { HomeComponent } from './components/home/home.component';
import { SharedModule } from '../shared/shared.module';
import { AppComponent } from './components/app/app.component';
import { RouterModule } from '@angular/router';
import { routes } from './core.routes';
import { MpsAuthService, MpsTokenInterceptor, MpsUserService, mpsFetchUser } from '../../../mps/mps-auth';
import { AuthModule as AppAuthModule } from '../auth/auth.module';
import { UserModule as AppUserModule } from '../user/user.module';
import { BrowserModule, DomSanitizer } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { HttpClient, HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { TranslateModule, TranslateLoader, TranslateService } from '@ngx-translate/core';
import {MatIconRegistry} from '@angular/material/icon';
import { NavigationComponent } from './components/navigation/navigation.component';

export function createTranslateLoader(http: HttpClient) {
  return new TranslateHttpLoader(http, './assets/i18n/', '.json');
}

@NgModule({
  declarations: [
    AppComponent,
    HeaderComponent,
    FooterComponent,
    HomeComponent,
    NavigationComponent,
  ],
  providers: [

    // Session : MpsUserService porte l'utilisateur connecte, MpsAuthService en derive
    // l'etat. L'APP_INITIALIZER charge l'utilisateur avant le demarrage du
    // routeur, sans quoi MpsLoggedInGuard renverrait tout le monde vers '/'.

    MpsUserService,
    MpsAuthService,
    {
        provide: APP_INITIALIZER,
        useFactory: mpsFetchUser,
        multi: true,
        deps: [MpsUserService]
    },
    {
        provide: HTTP_INTERCEPTORS,
        useClass: MpsTokenInterceptor,
        multi: true
    },
  ],
  imports: [

    BrowserModule,
    BrowserAnimationsModule,

    // Angular Packages

    HttpClientModule,
    RouterModule.forRoot(routes),

    // App packages

    SharedModule,
    AppAuthModule,
    AppUserModule,

    // Other

    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: createTranslateLoader,
        deps: [HttpClient],
      }
    }),
  ],
  bootstrap: [
    AppComponent
  ]
})
export class CoreModule {

  public constructor(@Optional() @SkipSelf() parent: CoreModule,
  iconRegistry: MatIconRegistry,
  sanitizer: DomSanitizer) {
    if (parent) {
      throw new Error('CoreModule should not be exported then imported by another module!');
    }
    
    const iconsFolder = 'assets/pictos/';
    const svgSuffix = '.svg';
    const svgFiles = [
      'account', 'delete', 'edit', 'warning', 'search', 'check'
    ];

    svgFiles.forEach(svgFile => {
      iconRegistry.addSvgIcon(svgFile, sanitizer.bypassSecurityTrustResourceUrl(iconsFolder + svgFile + svgSuffix));
    });
  }

}
